import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useUser } from '../context/userContext';
import messagesIcon from '../assets/menu/messages.svg'
import messagesActiveIcon from '../assets/menu/messages-filled.svg'
import messagesUnreadIcon from '../assets/menu/messages-unread.svg'
import messagesUnreadActiveIcon from '../assets/menu/messages-unread-filled.svg'
import homeIcon from '../assets/menu/home.svg'
import homeActiveIcon from '../assets/menu/home-filled.svg'
import statsIcon from '../assets/menu/statistic.svg'
import statsActiveIcon from '../assets/menu/statistic-filled.svg'
import settingsIcon from '../assets/menu/settings.svg'
import settingsActiveIcon from '../assets/menu/settings-filled.svg'
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { isLoggedIn, hasUnreadMessages } = useUser();
  const location = useLocation();
  const { t } = useTranslation();
  
  if (!isLoggedIn || location.pathname === '/') return null;

  return (
    <footer className="footer">
      <nav>
        <ul>
          <li>
            <NavLink to="/messages">
              <img src={
                location.pathname === '/messages'
                  ? (hasUnreadMessages ? messagesUnreadActiveIcon : messagesActiveIcon)
                  : (hasUnreadMessages ? messagesUnreadIcon : messagesIcon)
              } alt="messages" />
              <span>{t('messages')}</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/data">
              <img src={
                location.pathname === '/data' ? statsActiveIcon : statsIcon
              } alt="stats" />
              <span>{t('dataUsage')}</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard">
              <img src={
                location.pathname === '/dashboard' ? homeActiveIcon : homeIcon
              } alt="home" />
              <span>{t('dashboard')}</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/settings">
              <img src={
                location.pathname === '/settings'
                  || location.pathname === '/password-change' ? settingsActiveIcon : settingsIcon
              } alt="settings" />
              <span>{t('settings')}</span>
            </NavLink>
          </li>
        </ul>
      </nav>
    </footer>
  );
};

export default Footer;
